<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!token">
  <mat-card appearance="outlined">
    <div class="profile-selection">
      <mat-form-field>
        <input #state="ngModel" (ngModelChange)="filterProfiles(currentSearchTerm)" [(ngModel)]="currentSearchTerm"
               [matAutocomplete]="tdAuto" matInput
               name="state"
               placeholder="Select Profile">
      </mat-form-field>
      <mat-autocomplete #tdAuto="matAutocomplete" (optionSelected)="addProfile($event)">
        <mat-option *ngFor="let profile of filteredProfiles" [value]="profile.ProfileID">
          <span>
            {{ profile.firstName }}
            {{ profile.lastName }}
            <ng-container *ngIf="profile.nickName"> ({{profile.nickName}})</ng-container>
            <span> - {{profile.email}}</span>
          </span>
        </mat-option>
      </mat-autocomplete>
      <mat-form-field>
        <input [(ngModel)]="token.email" disabled matInput placeholder="Profile E-Mail"/>
      </mat-form-field>
    </div>
    <smart-input [(model)]="token" key="title"></smart-input>
    <smart-input [(model)]="token" key="logo"></smart-input>
    <smart-input [(model)]="token" key="endpoint"></smart-input>
    <smart-input [(model)]="token" key="type"></smart-input>
    <smart-input [(model)]="token" key="target"></smart-input>
    <mat-card appearance="outlined">
      <mat-card-title>Parameters</mat-card-title>
      <div *ngFor="let parameter of token.parameters; let i = index" class="parameters">
        <span class="parameter"><smart-input [(model)]="token.parameters[i]" key="name"></smart-input></span>
        <span class="parameter"><smart-input [(model)]="token.parameters[i]" key="value"></smart-input></span>
        <span class="parameter-encrypted"><smart-input [(model)]="token.parameters[i]" key="encrypted"></smart-input></span>
        <span class="actions"><button (click)="removeParameter(i)" class="ibexfusion-icon-button" mat-icon-button><mat-icon>delete</mat-icon></button></span>
      </div>
      <button (click)="addParameter()" class="ibexfusion-raised-button" mat-button>Add Parameter</button>
    </mat-card>
  </mat-card>
  <button (click)="onSave()" mat-button>Save</button>
</page-content>
